import editableDocuments from "./editableDocuments.component";

const editableDocumentsModule = angular
  .module("app.components.editableDocuments", [])
  .component("editableDocuments", editableDocuments);

export default editableDocumentsModule;



// WEBPACK FOOTER //
// ./src/components/editableDocuments/editableDocuments.module.js